import { render, staticRenderFns } from "./DoKoImgBtn.vue?vue&type=template&id=2c9b3898&"
import script from "./DoKoImgBtn.vue?vue&type=script&lang=ts&"
export * from "./DoKoImgBtn.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoImgBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports